import { Modal } from 'react-bootstrap'

import Role from './PollComponents/Role'
import Event from './PollComponents/Event'
import PollPage from './PollComponents/PollPage'

export default function Poll({ agenda, item }) {


  return (
    <Modal.Body
      style={{
        background: 'linear-gradient( #003f61 -100%, #78222f 151.58%)',
        position: 'relative'
      }}
      className='timer-header'
    >
      <Role item={item} />
      <Event item={item} />
      <PollPage agenda={agenda} item={item} />
    </Modal.Body >
  )
}